export default __webpack_public_path__ + "463e77efa29ffe74fa6d85f687672b8a.png";